import { GenericEventsRouteProvider } from '@wix/data-tools-generic-events';
import { AppShell } from '../components/AppShell';
import { YourAgentsBody } from '../components/symphony/agents/YourAgentsBody';
import { useNarrow } from '../lib/use-narrow';
import { useMyAgents } from '../lib/my-agents';
import { useTranslation } from '../lib/i18n';
import { usePageLoadBi } from '../lib/use-page-load-bi';

// "Your Agents" — the team the Maestro leads. Shows the genome beside the agent
// card pile (Figma `10261:86167`).
export default function AgentsPage() {
  usePageLoadBi({ page_name: 'your_agents' });
  const narrow = useNarrow();
  const { t } = useTranslation();

  // With no team the intro takes over the whole screen and carries its own title, so the
  // page header is dropped — matching the empty frame (Figma `10941:75358`), which has no
  // "Your Agents" heading above the illustration.
  const agents = useMyAgents();
  const empty = agents.status === 'ready' && agents.team.agents.length === 0;

  // The narrow screen renders its own header — a 32px title sitting tight to the task
  // strip beneath it, rather than AppShell's 40px page header and its 48px gap to
  // content — so there it takes AppShell as a pure layout wrapper.
  return (
    <GenericEventsRouteProvider value="agents">
      <AppShell title={narrow || empty ? '' : t('agents.title')}>
        <YourAgentsBody />
      </AppShell>
    </GenericEventsRouteProvider>
  );
}
